import { Vue, newVue, initVue } from '@/config/vue'

const init = () => {
  const Footer = Vue.component('footerComponent', () =>
    import(/* webpackChunkName: "footer" */ './Footer.vue')
  )
  newVue({
    render: h => h(Footer),
    mount: '.js-vue-footer',
  })
}
window.On.FooterVueInit = init

initVue({
  init({ isCheckout, isSpa }) {
    if (!isCheckout && !isSpa) init()
  },
})
